import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const getMyTrainingSlice = createSlice({
  name: "Training",

  initialState: { myTrainingData: [], trainingLoader: false },
  reducers: {
    setMyTrainingData: (state: any, action: PayloadAction<any>) => {
      console.log("ACTION @ EMP training--", action);
      state.myTrainingData = action.payload;
    },
    setTrainingLoader: (state: any, action: PayloadAction<any>) => {
      state.trainingLoader = action.payload;
    },
    resetMyTrainingData: (state: any) => {
      state = [];
    },
  },
});

export const { setMyTrainingData, resetMyTrainingData, setTrainingLoader } =
  getMyTrainingSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default getMyTrainingSlice.reducer;
